import styled from 'styled-components';

const CompanyAICIPageContainer = styled.div`
  box-sizing: border-box;
  width: 100%;
  margin: 10px auto 30px;
  padding: 0 30px 30px;
`;

export default CompanyAICIPageContainer;
